module.exports = __webpack_public_path__ + "img/saved.7df0e9dc.svg";